import React from 'react';
import {
  ListItem,
  ListItemText,
} from '@material-ui/core';

import classes from '../../css/getCSS';


const singleListItem = (props) => {
  const classNames = [classes.facetSingleItem];
  if (props.is_selected === 1) {
    classNames.push(classes.active);
  }
  return (
    <ListItem
      className={classNames.join(' ')}
      onClick={() => props.selectSingle(props.facet, props.value)}
    >
      <ListItemText primary={props.display_value} />
    </ListItem>
  );
};

export default singleListItem;



// WEBPACK FOOTER //
// ./src/search/components/SingleListItem.js